var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['inline-flex items-center px-1.5 py-1 rounded font-medium leading-none', _vm.textSize]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }